export const TimeKeepingEN = {
    "timekeepingSettings": "Timekeeping Settings",
    "timesheetFormula": "Timesheet Formula",
    "shiftWork": "Shift Work",
    "annualLeave": "Annual Leave",
    "setupHoliday": "Setup Holiday",
}